export function testPlatform(re: RegExp) {
  return typeof window !== 'undefined' && window.navigator !== null
    ? re.test(
        // @ts-expect-error TODO Our types don't know about userAgentData yet
        'userAgentData' in window.navigator ? window.navigator.userAgentData?.platform : window.navigator.platform,
      )
    : false;
}
